import React, { useState, useEffect } from 'react';
import './CloneTemplateModal.css';

function CloneTemplateModal({ template, onSubmit, onClose }) {
  const [formData, setFormData] = useState({
    name: '',
    description: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (template) {
      setFormData({
        name: `${template.name} copy`,
        description: template.description || ''
      });
    }
  }, [template]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name.trim()) {
      setError('Template name is required');
      return;
    }

    try {
      setLoading(true);
      setError(null);
      await onSubmit(formData);
    } catch (err) {
      console.error('Error cloning template:', err);
      setError('Error cloning template');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <div className="clone-template-overlay">
      <div className="clone-template-modal">
        <div className="modal-header">
          <h3>Clone Template</h3>
          <button onClick={handleCancel} className="close-button">
            <i className="ti ti-x"></i>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="clone-form">
          {error && (
            <div className="error-message">
              <i className="ti ti-alert-circle"></i>
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="name">Template Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Enter template name"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              placeholder="Enter template description"
              rows="4"
            />
          </div>

          <div className="form-actions">
            <button 
              type="button" 
              onClick={handleCancel} 
              className="cancel-button"
              disabled={loading}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="clone-button"
              disabled={loading}
            >
              {loading ? (
                <>
                  <i className="ti ti-loader ti-spin"></i>
                  Cloning...
                </>
              ) : (
                <>
                  <i className="ti ti-copy"></i>
                  Clone Template
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CloneTemplateModal; 